import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AppShell } from "./components/shell/AppShell";
import { LockedOverlay } from "./components/lifecycle/LockedOverlay";
import { useUi } from "./stores/ui";
import { UploadProgress } from "./components/browser/UploadProgress";

export default function App() {
  const theme = useUi((s) => s.theme);
  const lockedOverlay = useUi((s) => s.lockedOverlay);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else if (theme === "light") {
      root.classList.remove("dark");
    } else {
      const mql = window.matchMedia("(prefers-color-scheme: dark)");
      const apply = () =>
        mql.matches
          ? root.classList.add("dark")
          : root.classList.remove("dark");
      apply();
      mql.addEventListener("change", apply);
      return () => mql.removeEventListener("change", apply);
    }
  }, [theme]);

  return (
    <AppShell>
      <Outlet />
      {lockedOverlay && <LockedOverlay />}
      <UploadProgress />
      <Toaster position="bottom-right" theme="system" />
    </AppShell>
  );
}
